import {useEffect} from 'react';

import {signOutToPortal} from '../../../utils/signOutToPortal';

import {Center} from '@mantine/core';
import {PlatformLoader} from '@flexinet/ui-components';

export const SignOutPage = () => {

    useEffect(() => {
        const signOutAndRedirect = async () => {
            localStorage.setItem('amplify-signin-with-hostedUI', 'false');
            await signOutToPortal();
        }

        signOutAndRedirect()
    }, []);


    return (
        <Center>
            <PlatformLoader message={'Signing out...Please, wait!'}/>
        </Center>
    );
};
